function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { PRODUCTION_TIME_DRAWER } from 'swag-client-common/constants';
import { editProductionTimeInCart } from 'swag-client-common/redux/cart/cart.actions';
import { hidePopup, showPopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { isConfirmChangeSuperSpeedProdTimePopupShown, popupParamsSelector } from 'swag-client-common/redux/popup-manager/popup-manager.selector';
import { changeMethodIndex, changeTime } from '../../../redux/product/product.actions';
import { changeTime as changeTimeForRelatedProduct } from '../../../redux/related-product-builder-popup/related-product.actions';
import { ConfirmChangeSuperSpeedProdTimeComponent as Component } from './components/confirm-change-super-speed-prod-time-popup';
const titleSelector = createSelector(popupParamsSelector, ({
  fromSuperSpeed
}) => fromSuperSpeed ? 'Are you sure?' : 'Confirm action');
const messageSelector = createSelector(popupParamsSelector, ({
  toSuperSpeed,
  fromSuperSpeed,
  methodName
}) => {
  if (toSuperSpeed) {
    return `
        Great news! By switching your product to Super Speed, you will get it faster!
        Please note that "${methodName}" is the only embellishment method available
        for this product to meet the Super Speed production timeline. This will be
        reflected in your final order details and in the mockup we send for approval.
      `;
  }
  if (fromSuperSpeed) {
    return 'You are about to change your product from Super Speed to standard timelines. Please confirm you want to make this change. If you proceed, the new timeline for delivery will be confirmed upon checkout.';
  }
  return '';
});
const message2Selector = createSelector(popupParamsSelector, ({
  toSuperSpeed
}) => toSuperSpeed ? `Super Speed products will also default to 3 day shipping. You will have the
      option to select another shipping method at checkout if you prefer.` : '');
const mapStateToProps = createStructuredSelector({
  open: isConfirmChangeSuperSpeedProdTimePopupShown,
  params: popupParamsSelector,
  title: titleSelector,
  message: messageSelector,
  message2: message2Selector
});
const mapDispatchToProps = (dispatch, ownProps) => ({
  onConfirm: ({
    time,
    methodIdx
  }) => {
    dispatch(changeTime(time));
    dispatch(changeTimeForRelatedProduct(time));
    dispatch(editProductionTimeInCart(time, ownProps.isOnCheckout));
    dispatch(changeMethodIndex(methodIdx));
    dispatch(hidePopup());
  },
  onClose: prevPopupParams => {
    dispatch(hidePopup());
    dispatch(showPopup(_objectSpread({
      popup: PRODUCTION_TIME_DRAWER
    }, prevPopupParams)));
  }
});
export const ConfirmChangeSuperSpeedProdTimePopup = connect(mapStateToProps, mapDispatchToProps)(Component);